import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    // Your options go here
});

function openFancyUrl(url) {
    axios.get(url)
        .then(function(response) {
            let data = response.data;
            $.fancybox.open(data.content);
        })
        .catch(function(error) {
            console.log(error);
        });
}
document.addEventListener('click', function(event) {

    let fancyLink = event.target.closest('.js-fancy-link');
    if (!fancyLink && event.target.matches('.js-fancy-link')) {
        fancyLink = event.target;
    }
    if (fancyLink) {
        event.preventDefault();
        let link = fancyLink.getAttribute('href');
        openFancyUrl(link);
        return false;
    }
}, false);
window.openFlatInfo = function(flatElement) {
    let url = flatElement.dataset.url;
    let kitchen = flatElement.dataset.kitchen;
    let area = flatElement.dataset.area;
    let price = flatElement.dataset.price;
    let image = flatElement.dataset.image;

    let html = `
        <div class="fancy-flat">
            <div class="fancy-flat__left">
                <img class="fancy-flat__left__img img-fluid" src="${image}">
            </div>
            <div class="fancy-flat__right text-center">`;
    if (area) {
        html += `
        <div class="flat__parameter__item d-flex justify-content-between">
            <span>Общая площадь</span>
            <span>${ area }м<sup>2</sup></span>
        </div>`;
    }
    if (kitchen) {
        html += `
            <div class="flat__parameter__item d-flex justify-content-between">
                <span>Кухня</span>
                <span>${ kitchen }м<sup>2</sup></span>
            </div>`;
    }
    if (price) {
        html += `
        <div class="flat__parameter__item d-flex justify-content-between">
            <span>Цена</span>
            <span>${ price } руб</span>
        </div>`;
    }
    html += `
                <a href="${url}" class="btn fancy-flat__right__btn">Подробнее</a>
            </div>
        </div>`;
    const fancybox = new Fancybox([{
        src: html,
        type: "html",
    }, ]);
}
